
import env from '~/libs/env'

const validatedZips = {}

async function isValidZip (zipId, $axios) {
  const { data } = await $axios.get(`${env('apiUrl')}/zipcode/${zipId}`)

  return data.data.exists
}

export function zipValidator($axios) {
  let timer;
  return function(value) {
    return new Promise((resolve) => {
      if(!value) {
        return resolve(true)
      }
      if(value.length < 5) {
        return resolve(true)
      }
      if(validatedZips.hasOwnProperty(value)) {
        return resolve(validatedZips[value])
      }

      if (timer) {
        clearTimeout(timer)
        timer = null
      }

      timer = setTimeout(async () => {
        const valid = await isValidZip(value, $axios)
        validatedZips[value] = valid;
        resolve(valid);
      }, 500)
    })
  }
}

export default {
  zipValidator
}
